//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FiltrosGestaoAprovacao',
  data() {
    return {
      resourceFluxo: this.$api.fluxoAprovacao(this.$resource),
      resourceFluxoExecucao: this.$api.workflowPassos(this.$resource),
      tipos: [],
      passos: [],
      solicitantes: [],
      aprovadores: [],
      idPerfilPasso: null,
      filtros: {
        idAcordo: null,
        tipo: null,
        solicitante: null,
        aprovador: null,
      },
      valid: false,
      passoCliente: false,
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  methods: {
    requestTipos() {
      this.resourceFluxo.buscarTipos()
        .then((response) => {
          this.tipos = response.data;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarTarefas(tipo) {
      this.limparPassos();

      if (!tipo) {
        this.passos = [];
        return;
      }

      this.resourceFluxo.buscarDescricoes({ idTipo: tipo.id, status: 'AGUARDANDO_APROVACAO' })
        .then((response) => {
          this.passos = response.data;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    preencherFiltroCliente(hit) {
      this.limparSolicitante();
      this.limparAprovadores();
      if (!hit) {
        this.limparPassos();
        return;
      }
      this.passoCliente = hit.passocliente;

      this.buscarSolicitante({
        idTipo: this.filtros.tipo.id,
        passo: hit.descricao,
      });

      this.buscarAprovadores({
        idTipo: this.filtros.tipo.id,
        passo: hit.descricao,
        passoCliente: this.passoCliente,
      });
    },
    buscarAprovadores(parametros) {
      this.resourceFluxoExecucao.aprovadoresPasso(parametros)
        .then((response) => {
          this.aprovadores = response.data;
          if (response.data && response.data.length > 0 && response.data[0].idperfil) {
            this.idPerfilPasso = response.data[0].idperfil;
          } else {
            this.idPerfilPasso = null;
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarSolicitante(parametros) {
      this.resourceFluxoExecucao.solicitantesPasso(parametros)
        .then((response) => {
          this.solicitantes = response.data;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    limparAprovadores() {
      this.filtros.aprovador = null;
      this.aprovadores = [];
    },
    limparSolicitante() {
      this.filtros.solicitante = null;
      this.solicitantes = [];
    },
    limparPassos() {
      this.passoCliente = false;
      this.filtros.passo = null;
    },
    filtrar() {
      if (this.$refs.form.validate()) {
        this.$emit('filtrar', this.filtros);
        this.$emit('recarregarUsuarios', this.idPerfilPasso);
      }
    },
    limparFiltros() {
      this.$refs.form.reset();
    },
  },
  mounted() {
    this.requestTipos();
  },
};



// WEBPACK FOOTER //
// ./src/spa/gestao-aprovacao/FiltrosGestaoAprovacao.vue?vue&type=script&lang=js&